//
//
//
//
//
//
//
//
//

import { resetOrientation, dataURLtoFile } from '~/utils';
export default {
  name: 'Avatar',
  props: {
    imageUrl: { type: String, default: '' },
    onUploadFile: { type: Function, default: () => {} },
  },
  data() {
    return {
      avatarUrl: null,
      file: null,
    };
  },
  watch: {
    imageUrl() {
      this.avatarUrl = this.imageUrl;
    },
  },
  methods: {
    previewFile(file) {
      const reader = new FileReader();
      let that = this;
      reader.onload = function () {
        // convert image file to base64 string
        that.avatarUrl = reader.result;
        // 壓縮圖片
        resetOrientation(reader.result, imgSrc => {
          setTimeout(() => {
            that.avatarUrl = imgSrc;
          }, 100);
          const filename = new Date().getTime() + '.jpeg';
          const newFile = dataURLtoFile(imgSrc, filename);

          const payload = {
            id: that.$route.query.id,
            file: newFile,
          };

          that.onUploadFile(payload);
        });
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    beforeAvatarUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImg) {
        this.$message.error('上傳頭像圖片只能是 JPG 或 PNG 格式');
      }
      if (!isLt2M) {
        this.$message.error('上傳頭像圖片大小不能超過 2MB!');
      }
      if (isImg && isLt2M) {
        this.file = file;
        this.previewFile(file);
      }
      return false;
    },
  },
  created() {
    this.avatarUrl = this.imageUrl;
  },
};
